import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
} from '@angular/core';

import { BaseUI } from '../../base.ui';
import { Client } from '../../../domain/data';
import { ClientRelation, ClientType, LegalGuardianType, Nature } from '../../../../core';
import { ContractFormParticipantMinorDisabledPersonComponent } from '../form-participant-minor-disabled-person/contract-form-participant-minor-disabled-person.component';
import { ParentEvents } from '../../../utils/parent-events.service';
import { RecaptchaDirective } from '../../../directives/recaptcha.directive';

import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'thr-contract-form-participant',
    templateUrl: './contract-form-participant.component.html',
    styleUrls: ['./contract-form-participant.component.scss'],
})
export class ContractFormParticipantComponent extends BaseUI implements AfterViewInit, OnChanges, OnDestroy, OnInit {
    public ClientRelation: typeof ClientRelation = ClientRelation;
    public ClientType: typeof ClientType = ClientType;

    public addingTutor = false;
    public disabledLegal = false;
    public isEditing = false;
    public isClientPortal = environment.portalClient;

    @Input()
    client: Client;

    @Input()
    isFirst = false;

    @Input()
    isLegalPerson = false;

    @Input()
    tutors: Client[];

    @Output()
    cancel: EventEmitter<void> = new EventEmitter();

    // tslint:disable-next-line:no-output-native
    @Output()
    complete: EventEmitter<Client> = new EventEmitter();

    @ViewChild(ContractFormParticipantMinorDisabledPersonComponent)
    minorForm: ContractFormParticipantMinorDisabledPersonComponent;

    @ViewChild('recaptchaDirective')
    recaptchaDirective: RecaptchaDirective;

    constructor(parentEvents: ParentEvents) {
        super(parentEvents);
    }

    get showAddingTutorButton(): boolean {
        return [ClientType.MINOR, ClientType.DISABLED].indexOf(this.client.type) !== -1 && !this.addingTutor;
    }

    ngOnInit() {
        if (!this.client) {
            this.createClient();
        }
    }

    private createClient() {
        this.client = new Client();
        this.client.docExpirationDatePermanent = false;
        this.client.phoneExonerate = false;
        this.client.emailExonerate = false;
        this.client.nature = Nature.NATURAL;
        this.client.type = ClientType.NATURAL_PERSON;

        if (this.isLegalPerson) {
            this.client.legalGuardianType = LegalGuardianType.ATTORNEY_IN_FACT;
            this.client.legalGuardianRelation = ClientRelation.AUTHORIZED;
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if ('client' in changes && changes.client.currentValue) {
            this.isEditing = true;
        }
    }

    onCancel() {
        this.cancel.emit();
    }

    onAddingTutor(value: boolean) {
        setTimeout(() => {
            this.addingTutor = value;
        });
    }

    onAddTutor() {
        if (this.minorForm) {
            this.minorForm.onAddTutor();
        }
    }

    onSubmit() {
        if (this.isClientPortal) {
            this.recaptchaDirective.refresh().then(() => {
                this.complete.emit(this.client);
            });
        } else {
            this.complete.emit(this.client);
        }
    }
}
